exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo{    height: 73px !important;}\r\n.pull-left a{color: #fff;text-decoration: none;\r\n    font-weight: 900;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/menuitems/menuitems.component.css
// module id = ../../../../../src/app/menuitems/menuitems.component.css
// module chunks = main